import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Separator } from 'draft-js-static-toolbar-plugin'
import { createInlineStyleButton, createBlockStyleButton } from 'draft-js-buttons'
import BoldIcon from '../../../common/icons/BoldIcon'
import ItalicIcon from '../../../common/icons/ItalicIcon'
import OrderedListIcon from '../../../common/icons/OrderedListIcon'
import UnorderedListIcon from '../../../common/icons/UnorderedListIcon'
import LinkIcon from '../../../common/icons/LinkIcon'
import UploadFileIcon from '../../../common/icons/UploadFileIcon'

const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px 0 #9B9B9B;
`
const FormattingButton = styled.div`
    background: #ffffff;
    color: #888;
    font-size: 18px;
    border: 0;
    vertical-align: bottom;
    height: 34px;
    width: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: #f3f3f3;
      outline: 0;
    }
    cursor: pointer;
`
const BoldButton = createInlineStyleButton({ style: 'BOLD', children: <BoldIcon /> })
const ItalicButton = createInlineStyleButton({ style: 'ITALIC', children: <ItalicIcon /> })
const OrderedListButton = createBlockStyleButton({ blockType: 'ordered-list-item', children: <OrderedListIcon /> })
const UnorderedListButton = createBlockStyleButton({ blockType: 'unordered-list-item', children: <UnorderedListIcon /> })

const ToolbarButtons = ({ onLinkButtonClick, onFileUploadClick, ...externalProps }) => (
  <ButtonsContainer>
    <BoldButton {...externalProps} />
    <ItalicButton {...externalProps} />
    <Separator {...externalProps} />
    <UnorderedListButton {...externalProps} />
    <OrderedListButton {...externalProps} />
    <Separator {...externalProps} />
    <FormattingButton 
      className='linkIcon'
      onClick={onLinkButtonClick}>
        <LinkIcon />
    </FormattingButton>
    <FormattingButton 
      className='uploadIcon'
      onClick={onFileUploadClick}>
        <UploadFileIcon />
    </FormattingButton>
  </ButtonsContainer>
)

ToolbarButtons.propTypes = {
  onLinkButtonClick: PropTypes.func.isRequired,
  onFileUploadClick: PropTypes.func.isRequired
}

export default ToolbarButtons
